import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bank-external-callback',
  template: '',
})
export class BankExternalCallbackComponent implements OnInit {
  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);
    const state = params.get('state');
    const apiKey = params.get('api_key');

    if (window.opener && state && apiKey) {
      const targetOrigin = window.location.origin;
      window.opener.postMessage({ state, apiKey }, targetOrigin);
      requestAnimationFrame(() => { window.close(); });
    } else {
      console.warn('window.opener または state/api_key が見つかりません');
    }
  }
}
